import { apiClient } from './client';
import type { Account, AccountsResponse, AccountsStats, AccountFilters } from '@/types/account';

export async function getAccounts(filters: AccountFilters = {}): Promise<AccountsResponse> {
  const params = new URLSearchParams();

  if (filters.role && filters.role !== 'all') {
    params.append('role', filters.role);
  }
  if (filters.search) {
    params.append('search', filters.search);
  }
  if (filters.page) {
    params.append('page', filters.page.toString());
  }
  if (filters.limit) {
    params.append('limit', filters.limit.toString());
  }
  if (filters.sortBy) {
    params.append('sortBy', filters.sortBy);
  }
  if (filters.sortOrder) {
    params.append('sortOrder', filters.sortOrder);
  }

  const response = await apiClient.get<AccountsResponse>(`/api/accounts?${params.toString()}`);
  return response.data;
}

export async function getAccountsStats(): Promise<AccountsStats> {
  const response = await apiClient.get<AccountsStats>('/api/accounts/stats');
  return response.data;
}

export async function getAccount(id: number): Promise<Account> {
  const response = await apiClient.get<Account>(`/api/accounts/${id}`);
  return response.data;
}
